import React, { useState } from "react";
import logo from './assets/Elumo Logo Rund.png';
import oss from './assets/Oss.jpg';
import oystein from './assets/Oystein.jpg';
import natalia from './assets/Natalia.jpg';
import instagramIcon from './assets/instagram.png';
import facebookIcon from './assets/facebook.png';
import foredragoystein from './assets/ForedragOystein.jpg';
import familieterapi from './assets/Familieterapi.jpg';
import coaching from './assets/Coaching.jpg';
import helsesamling from './assets/Helsesamling.JPG';
import samtaleterapi from './assets/Samtaleterapi.JPG';
import personvern from './assets/Personvern.JPG';
import personligtrening from './assets/Personlig trening.JPG'
import ft from './assets/FT.JPG';
import kristen from './assets/Kristen.jpg';
import parterapiekte from './assets/parterapi.jpg';
import coachingekte from './assets/Coachingekte.jpg';
import kontaktoss from './assets/Kontaktoss.jpg';
import håp from './assets/Håp.JPG';
import './App.css';
import tistLogo from "./assets/TIST Certified Logo.png";

export default function App() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus({ type: "error", text: "Fyll ut alle feltene før du sender." });
      return;
    }
    setTimeout(() => {
      setStatus({ type: "success", text: "Takk! Meldingen din er sendt." });
      setForm({ name: "", email: "", message: "" });
    }, 700);
  }

  return (
    <>
      <div className="App" id="top">
        {/* Header */}
        <header className="App-header">
          <img src={logo} alt="Elumo logo" className="logo-small" />
          <h1 className="site-title">
          <span className="brand">Elumo </span>
          <span className="tagline">Terapeutiske Tjenester</span>
          </h1>
          <p>Samtaleterapi • Støttesamtaler • Coaching • Rådgivning • Foredrag • Personlig trening • Helsesamlinger</p>
        </header>

        <main className="main-content">
          {/* Om oss */}
          <div className="om-oss-container stylish-om-oss" id="om-oss">
            <div className="om-oss-tekst">
              <h2>Om oss</h2>
              <p>
                Vi er Øystein og Natalia Sagmo Sivertsen, et ektepar i livet 
                og kollegaer i det terapeutiske arbeidet. 
                Med ulik bakgrunn, men felles verdier og visjon, drifter vi 
                Elumo Terapeutiske Tjenester for å tilby lett tilgjengelige, rimelige 
                og kvalitetsrike terapeutiske tjenester. <br/> <br/>
                 Visjonen vår er enkel, men viktig: 
                 <li>Å skape tjenester som er helsefremmende, helbredende og helhetlige.</li> 
                 <li>Å skape rom til å fokusere på hele mennesket - sinn, kropp, relasjoner og mening.</li>   
                 <li>Å skape tid for å utforske, bearbeide, vokse og bli styrket med åpenhet og trygghet, uansett utgangspunkt.</li> 
                 <li>Å skape varme menneskemøter, ekthet, empati, tilstedeværelse og faglighet.</li> 
                 </p>
            </div>
            <img src={oss} alt="Om oss" className="om-oss-bilde" />
          </div>

          {/* Øystein */}
          <div className="om-oss-container">
            <div className="om-oss-tekst">
              <h2>Øystein</h2>
              <p>
                Øystein er en psykoterapeut med bachelor i psykolog og full sertifisering (Level 3 av 3) i Traumeinformert stabiliseringsterapi 
                (TIST). 
                Denne videreutdanningen gir 
                fordypning i å arbeide med traumer og andre alvorlige relaterte
                 problemstillinger med avansert kompetanse.<br/><br/>
                 
                 Øystein har klinisk erfaring med samtaleterapi for
                  ulike psykiske plager og lidelser, inkludert komplekse traumer, angst, 
                  depresjon, emosjonell ustabilitet, avhengighet, bipolar lidelse, 
                  tvangslidelser (OCD), sosial mutisme og suicidalitet. <br/><br/>

                  Øysteins terapeutiske tilnærming kjennetegnes av varme, respekt og genuin forståelse. 
                  Med sin kompetanse og varme opplever klienter
                  å føle seg trygt ivaretatt og hjulpet med å forstå og finne seg selv.  
                 
                 
              </p>
            </div>
            <img src={oystein} alt="Øystein" className="om-oss-bilde" />
                          <div className="tema-wrapper">
    <h3>Språk</h3> 

    <div className="tema-grid">
      <div>Norsk</div>
      <div>Engelsk</div>
                  <div className="logo-wrapper">
  <img src={tistLogo} alt="Sertifisering" className="logo-liten" />
</div>  
    </div>
</div>
          </div>

          {/* Natalia */}
          <div className="om-oss-container">
            <div className="om-oss-tekst">
              <h2>Natalia</h2>
              <p>
                Natalia er utdannet psykolog og personlig trener, med bred erfaring fra både 
                klinisk og forebyggende arbeid med barn, ungdom, voksne og eldre. Hun har 
                jobbet som psykolog i Familievernet, med samtaleterapi, foreldreveiledning, kurs og støttesamtaler, for enkeltpersoner, 
                par og familier. <br/><br/>
                
                Hun er opptrent i Traumeinformert stabiliseringsterapi (TIST) for enkeltpersoner 
                og Emosjonsfokusert terapi (EFT) for par og familier, noe som gir henne 
                kompetanse til å møte ulike problemstillinger på en trygg, kompetent og strukturert måte.
                 <br/><br/>
                 
                 Hun er spesielt interessert i sammenhengen mellom kropp og sinn, og hvordan traumer, 
                 livsstil, relasjoner og psykologiske prosesser påvirker helsen og livskvaliteten. 
                 Blant annet har hun klinisk erfaring med samtaleterapi for ulike relasjonelle problemer
                  eller psykiske plager/lidelser som eksempelvis utbrenthet, perfeksjonisme, angst, ADHD, depresjon, 
                  PTSD, sinneproblematikk, dissosiasjon, spiseforstyrrelser etc. Hun har også erfaring
                  med coaching og rådgivning for enkeltpersoner for støtte og veiledning i selvutviklingsprosesser.

              </p>
            </div>
            <img src={natalia} alt="Natalia" className="om-oss-bilde" />
              <div className="tema-wrapper">
    <h3>Språk</h3>

    <div className="tema-grid">
      <div>Norsk</div>
      <div>Engelsk</div>
      <div>Polsk</div>
    </div>
</div>
          </div>

<section id="services" className="section services-table-section">
  <h2>Tjenester og priser</h2>

  <table className="price-table">
    <thead>
      <tr>
        <th>Tjeneste</th>
        <th>Varighet</th>
        <th>Pris</th>
        <th>Format</th>
      </tr>
    </thead>
    <tbody>
  <tr onClick={() => document.getElementById("tilnærming").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Individualterapi</td>
    <td>60 / 90 min</td>
    <td>700 kr / 950 kr</td>
    <td>Digitalt / fysisk</td>
  </tr>
  <tr onClick={() => document.getElementById("støttesamtale").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Støttesamtaler</td>
    <td>60 / 90 min</td>
    <td>700 kr / 950 kr</td>
    <td>Digitalt / fysisk</td>
  </tr>
  <tr onClick={() => document.getElementById("coaching").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Coaching / Rådgivning</td>
    <td>60 / 90 min</td>
    <td>700 kr / 950 kr</td>
    <td>Digitalt / fysisk</td>
  </tr>
  <tr onClick={() => document.getElementById("parterapi").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Parterapi</td>
    <td>60 / 90 min</td>
    <td>950 kr / 1200 kr</td>
    <td>Digitalt / fysisk</td>
  </tr>
  <tr onClick={() => document.getElementById("familieterapi").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Familieterapi</td>
    <td>60 / 90 min</td>
    <td>1200 kr / 1450 kr</td>
    <td>Digitalt / fysisk</td>
  </tr>
  <tr onClick={() => document.getElementById("personligtrening").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Personlig trening</td>
    <td>60 min</td>
    <td>700 kr</td>
    <td>Digitalt / fysisk</td>
  </tr>
  <tr onClick={() => document.getElementById("kurs-foredrag").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Foredrag / Kurs / Workshops</td>
    <td>—</td>
    <td>Pris etter avtale</td>
    <td>Fysisk / digitalt</td>
  </tr>
  <tr onClick={() => document.getElementById("helsesamlinger").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Helsesamlinger</td>
    <td>—</td>
    <td>Pris etter avtale</td>
    <td>Fysisk</td>
  </tr>
    <tr onClick={() => document.getElementById("contact").scrollIntoView({ behavior: "smooth" })} className="clickable-row">
    <td>Skriftlig dokumentasjon</td>
    <td>30 min</td>
    <td>500kr</td>
    <td>—</td>
  </tr>
</tbody>

  </table>

  <p className="service-note">
    <em>
      Våre tjenester kan bli utført på kontoret vårt i naturskjønne omgivelser på Dokka<br />
      eller et annet sted etter avtale. 
    </em>
  </p>
</section>


{/* Tilnærming */}
<div className="om-oss-container" id="tilnærming">

  <div className="om-oss-tekst">
    <h2>Individualterapi</h2>
    <p>
Denne tjenesten er for deg som ønsker hjelp med å få mer indre ro og kontroll, 
forstå deg selv bedre og bearbeide det du trenger. 
Fokuset er på stabilisering, utforskning, forståelse, regulering og bearbeiding. <br/> <br/>

Vi er begge opptrente i Traumeinformert stabiliseringsterapi (TIST). TIST er en moderne 
integrasjon av flere av de mest anerkjente psykoterapeutiske metodene, som CBT, MCT,
sensorimotorisk terapi og IFS. Metoden egner seg særlig godt til å arbeide med traumer og
andre alvorlige problemstillinger på et avansert nivå, samtidig som den også kan brukes ved 
mindre komplekse utfordringer. <br/><br/>

Med TIST fokuserer vi på å gjenvinne indre ro og kontroll i livet
ved å aktivere hjernens kontrollsenter (prefrontal cortex). Deretter hjelper vi deg 
med å bearbeide vanskelige tanker, følelser, deler ved deg selv. 
Vi kan også bearbeide traumatiske minner, 
men med TIST-metoden er det ikke nødvendig for å få effektiv behandling <br/><br/>

Ved behov arbeider vi integrativt, og kombinerer TIST med andre metoder, 
som IFS, CBT, MCT, EFT og sensorimotorisk terapi. Dette 
gjør at vi kan tilpasse behandlingen til den enkelte klient og gi best mulig støtte og utvikling. 
    </p>
  </div>

  <img 
    src={samtaleterapi} 
    alt="Tilnærming" 
    className="om-oss-bilde" 
  />

  {/* Temaer INNI sam— me boks */}
  <div className="tema-wrapper">
    <h3>Typiske temaer</h3>

    <div className="tema-grid">
      <div>Kompleks PTSD</div>
      <div>Traumer</div>
      <div>Tvangstanker</div>
      <div>Dissosiative lidelser</div>
      <div>Depresjon</div>
      <div>Stress / angst</div>
      <div>Selvskading</div>
      <div>Utbrenthet</div>
      <div>“Flink pike syndrom”</div>
      <div>Skam / selvforakt</div>
      <div>Selvmordstanker</div>
      <div>Spiseforstyrrelser</div>
      <div>Emosjonell ustabilhet</div>
      <div>Avhengigheter</div>
      <div>Selvbilde / identitet</div>
      <div>Tilknytningsstil</div>
      <div>Sinne</div>
      <div>ADHD</div>
      <div>Overtenkning</div>
    </div>
  </div>

<p className="individualterapi-warning">
   ⚠️ Vi tilbyr ikke psykologisk utredning.
</p>

</div>

<div className="om-oss-container" id="støttesamtale">
  <div className="om-oss-tekst">
    <h2>Støttesamtaler</h2>
    <p>
      Denne tjenesten er for deg som står i en krevende livssituasjon og har behov for støtte,
       sortering og avlastning. Samtalene gir rom for å sette ord på det som oppleves overveldende 
       for å skape oversikt, ro og stabilitet i en utfordrende periode. <br/><br/>

       Fokuset er på å sortere tanker og følelser, normalisere reaksjoner og gi støtte i møte 
       med livsoverganger, belastninger, endringer eller relasjonelle utfordringer. 
       Samtalene kan fungere som et pusterom der du ikke trenger å prestere eller «løse» noe, 
       men kan bli møtt med forståelse og trygghet. <br/><br/>

       Prosessen tilpasses din situasjon og ditt tempo, med mål om å lette trykket 
       og styrke din evne til å stå i det som er.

    </p>
  </div>
  <img src={coaching} alt="Par- og familieterapi" className="om-oss-bilde" />
    <div className="tema-wrapper">
    <h3>Typiske temaer</h3>
    <div className="tema-grid">
      <div>Hverdagsstress og belastninger</div>
      <div>Behov for å "lufte"</div>
      <div>Livskriser / livsendringer</div>
      <div>Sykdom</div>
      <div>Sorg</div>
      <div>Relasjonelle vansker</div>
      <div>Studier-/jobbskifte</div>
      <div>Støtte for pårørende</div>
      <div>Seksualitet</div>
      <div>Eksistensielle temaer</div>
      <div>Emosjonell overbelastning</div>
    </div>
  </div>
</div>

<div className="om-oss-container" id="coaching">
  <div className="om-oss-tekst">
    <h2>Coaching / Rådgivning</h2>
    <p>
      Denne tjenesten er for deg som ønsker en sparrepartner for målrettet bevisstgjøring, 
      refleksjon og personlig/relasjonell utvikling. Samtalene gir rom for å utforske hva 
      som former dine valg, reaksjoner og relasjoner, samt hva som kan gi retning, mening og 
      balanse i livet. <br/><br/> 

      Vi arbeider med å hjelpe klientene å tydeliggjøre deres mål og verdier, 
      styrke indre integritet og gi nye perspektiver i deres prosesser.
       Det legges vekt på å utvikle refleksjonsevne, selvinnsikt og ansvarlighet, slik at endringer
        kan skje på en solid og varig måte. 

    </p>
  </div>
  <img src={parterapiekte} alt="Par- og familieterapi" className="om-oss-bilde" />
    <div className="tema-wrapper">
    <h3>Typiske temaer</h3>
    <div className="tema-grid">
      <div>Personlig vekst</div>
      <div>Karakterbygging</div>
      <div>Verdikartlegging</div>
      <div>Meningsdanning</div>
      <div>Relasjonsrådgivning</div>
      <div>Valg av partner</div>
      <div>Livsstilsendring</div>
      <div>Stressmestring</div>
      <div>Åndelighet</div>
      <div>Religiøsitet</div>
      <div>Veivalg</div>
      <div>Sinnemestring</div>
    </div>
  </div>
</div>

<div className="om-oss-container" id="parterapi">
  <div className="om-oss-tekst">
    <h2>Parterapi</h2>
    <p>
      Parterapi er for par som ønsker støtte til å forstå og styrke relasjonen sin, 
      enten man står i konkrete utfordringer eller ønsker å utvikle bedre kontakt og samspill. 
      Samtalene gir rom for å utforske mønstre i kommunikasjon, emosjonell nærhet og
       konflikthåndtering. <br/><br/>

       Natalia har erfaring med parterapi fra Familievernet, og 
       arbeider med prinsipper fra Emosjonsfokusert parterapi og Traumeinformert stabiliseringsterapi. 
       Samtalene legger vekt på å skape forståelse for egne og hverandres reaksjoner, 
       behov og sårbarheter, slik at paret kan utvikle bedre måter å kommunisere på. <br/><br/>

       Prosessen tilpasses parets situasjon og tempo, med mål om å styrke forståelse, tilknytning, 
       tillit og samarbeid, samt legge grunnlag for mer åpenhet, nærhet og tydelighet.

    </p>
  </div>
  <img src={oss} alt="Traumeterapi" className="om-oss-bilde" />
  <div className="tema-wrapper">
  <h3>Typiske temaer</h3>

  <div className="tema-grid">
    <div>Styrke parforholdet</div>
    <div>Kommunikasjon</div>
    <div>Kjærlighetsspråk</div>
    <div>Ekteskapsforberedelse</div>
    <div>Sjalusi</div>
    <div>Emosjonell nærhet</div>
    <div>Fysisk intimitet</div>
    <div>Konflikthåndtering</div>
    <div>Utroskap</div>
  </div>
</div>

</div>

<div className="om-oss-container familieterapi-container" id="familieterapi">
  <div className="om-oss-tekst familieterapi-tekst">
    <h2>Familieterapi</h2>
    <p>
      Familieterapi er for familier som ønsker støtte i møte med utfordringer som 
      påvirker samspill, trygghet og tilhørighet. Samtalene gir rom for å utforske 
      kommunikasjon, relasjoner og følelsesmessige mønstre, med mål om økt forståelse
       og bedre kontakt mellom familiemedlemmene. <br/><br/>

       Natalia har erfaring med familieterapi fra Familievernet, og arbeider 
       med en tilnærming som vektlegger forståelse, emosjonell trygghet, stabilitet 
       og regulering. Det legges til rette for at alle stemmer blir hørt i et tempo 
       som ivaretar både barn og voksne, for å utvikle nye måter å møte hverandre på. <br/><br/>

       Prosessen tilpasses familiens situasjon og behov, med fokus på å styrke bånd, 
       håndtere konflikter og skape et trygt samarbeid.

    </p>
  </div>
  <img src={ft} alt="Familieterapi" className="om-oss-bilde familieterapi-bilde" />

  <div className="tema-wrapper">
  <h3>Typiske temaer</h3>

  <div className="tema-grid">
    <div>Kommunikasjon</div>
    <div>Samspill i familien</div>
    <div>Emosjonell nærhet</div>
    <div>Konflikthåndtering</div>
    <div>Kulturkonflikter</div>
    <div>Sykdom</div>
    <div>Foreldreveiledning</div>
  </div>
</div>

</div>

<div className="om-oss-container" id="personligtrening">
  <div className="om-oss-tekst">
    <h2>Personlig trening</h2>
    <p>
      Personlig trening er for deg som ønsker å styrke kroppen, øke energi, 
      finne balansen mellom aktivitet og hvile, samt utvikle sunne vaner 
      som støtter både fysisk og mental helse. <br/><br/> 
      
      Coaching-timene og/eller treningen 
      tilpasses dine mål, ditt nivå og din livssituasjon. Gjennom målrettede samtaler 
      og/eller treningsøkter får du støtte til å gradvis styrke kroppen, 
      utvikle gode rutiner og øke bevisstheten rundt egen helse. Prosessen tilpasses deg 
      og ditt tempo, med fokus på balanse, mestring, motivasjon 
       og bærekraftige resultater over tid. <br/><br/>
       
       Natalia er sertifisert personlig trener (EQS Level 4), og kombinerer faglig kunnskap 
       med en helhetlig tilnærming som tar hensyn til både kropp og sinn. Gjennom målrettede 
       samtaler eller treningsøkter får du støtte til å styrke kroppen, utvikle gode rutiner og øke bevisstheten 
       rundt egen helse. <br/><br/>
       
       To spesialprogrammer er for øyeblikket under utvikling. Den ene er rettet mot 
       stress/utmattelse og den andre følger den kvinnelige syklusen.

    </p>
  </div>
  <img src={personligtrening} alt="Personlig utvikling" className="om-oss-bilde" />
  <div className="tema-wrapper">
  <h3>Typiske fokusområder</h3>

  <div className="tema-grid">
    <div>Treningsglede</div>
    <div>Grunnleggende styrke og utholdenhet</div>
    <div>Muskelbygging</div>
    <div>Mobilitet</div>
    <div>Fleksibilitet</div>
    <div>Hjemmetrening</div>
    <div>Utendørstrening</div>
    <div>Stressvennlig trening</div>
    <div>Livsstilsendring</div>
    <div>Balanse mellom aktivitet og hvile</div>
    <div>Restitusjon</div>
  </div>
</div>

</div>
          {/* Kurs og foredrag */}
          <div className="om-oss-container" id="kurs-foredrag">
            <div className="om-oss-tekst">
              <h2>Foredrag</h2>
              <p>
                Vi tilbyr foredrag, kurs, workshops og undervisning for barn, ungdom og voksne, 
                med mål om å styrke forståelse, refleksjon og personlig/relasjonell utvikling. <br/> <br/>
                
                Innholdet kombinerer teori og praksis på en tilgjengelig og engasjerende måte, 
                og tar opp temaer som berører menneskers indre liv, samspill, mestring og mening 
                i hverdagen. Øystein har erfaring som underviser i POFU, kursholder i 
                konflikthåndtering i Mental Helse, og hatt ulike foredrag hos Mental 
                Helse Ungdom Kongsberg. Natalia har erfaring i å undervise og holde foredrag 
                for ungdom og voksne om ulike helserelaterte teamer. Sammen har Natalia 
                og Øystein holdt foredrag og kurs i flere år for ulike forsamlinger og skoler. <br/> <br/>
                 
                 Formidlingen vektlegger åpenhet, gjenkjennelse og inspirasjon, og gir deltakerne både 
                 innsikt og praktiske perspektiver de kan ta med seg videre. Innhold og format tilpasses
                  målgruppe, kontekst og behov, og egner seg for skoler, arbeidsplasser, organisasjoner 
                  og andre fellesskap.

              </p>
            </div>
            <img src={foredragoystein} alt="Kurs og foredrag" className="om-oss-bilde" />
            <div className="tema-wrapper">
  <h3>Typiske temaer</h3>

  <div className="tema-grid">
    <div>Traumer</div>
    <div>Konflikthåndtering</div>
    <div>Relasjoner</div>
    <div>Kommunikasjon</div>
    <div>Avhengighet</div>
    <div>Sosiale medier</div>
    <div>Utbrenthet</div>
    <div>Skam</div>
    <div>Angst</div>
    <div>Depresjon</div>
    <div>Perfeksjonisme</div>
    <div>Åndelighet</div>
    <div>Religiøsitet</div>
    <div>Symbolikk</div>
    <div>Kognitiv psykologi</div>
  </div>
</div>

          </div>

          {/* Helsesamlinger */}
          <div className="om-oss-container" id="helsesamlinger">
            <div className="om-oss-tekst">
              <h2>Helsesamlinger</h2>
              <p>
                Helsesamlinger er for deg som ønsker å trekke deg litt tilbake fra hverdagen 
                og gi rom for hvile, inspirasjon og refleksjon. Samlingene foregår i rolige 
                og naturskjønne omgivelser på et småbruk, og gir en opplevelse som kombinerer
                 kunnskap, nærvær og ro. <br/><br/>
                 
                 Gjennom foredrag om ulike helse- og utviklingstemaer, samtaler, 
                 enkel bevegelse og naturkontakt, får du mulighet til å roe ned, reflektere 
                 og hente inspirasjon. Mellom foredragene serveres smaksrik og nærende mat 
                 som understøtter opplevelsen, og det legges til rette for allergier og andre
                  eventuelle behov. <br/><br/>
                  
                  Helsesamlinger passer for venner, kollegaer, par, familier eller små grupper 
                  som ønsker å gjøre noe meningsfullt sammen, eller for deg som ønsker
                   å komme alene og bli en del av et varmt og inkluderende fellesskap. <br/><br/>
                   
                   Følg med på vår Facebook eller Instagram side for oppdateringer, 
                   arrangementer og helsesamlinger. Det er også mulig å komponere en 
                   egen helsesamling tilpasset deres ønsker og behov.

              </p>
            </div>
            <img src={helsesamling} alt="Helsesamlinger" className="om-oss-bilde" />
          </div>

          {/* Mulighet for kristensensitivt perspektiv */}
          <div className="om-oss-container" id="kristen">
            <div className="om-oss-tekst">
              <h2>Mulighet for et kristent perspektiv</h2>
              <p>
                Mange kristne som sliter psykisk opplever at ordinær 
                psykisk helsehjelp ikke alltid rommer eller forstår deres trosliv. 
                Den kristne dimensjonen av livet er ofte en viktig del av både 
                identitet og livets belastninger, og når dette ikke tas med i bearbeidingen,
                kan helheten mangle. 
                <br/> <br/>
                Som kristne behandlere har både Øystein og Natalia solid erfaring 
                med å møte kristne klienter som ønsker at troen skal være en naturlig
                 del av prosessen.
                 <br/> <br/>
                 Derfor kan alle våre tjenester tilpasses en kristen trosforståelse, 
                 uten at det går på bekostning av faglighet eller metode. 
                 Hvor mye dette integreres, bestemmer du selv, 
                 og det gjøres alltid på en respektfull, trygg og ikke-dømmende måte.

                
              </p>
            </div>
            <img src={kristen} alt="Helsesamlinger" className="om-oss-bilde" />
          </div>


{/* Personvern */}
<div className="om-oss-container familieterapi-container" id="personvern">
  <div className="om-oss-tekst familieterapi-tekst">
    <h2>Praktisk informasjon og personvern</h2>
    <ul>
      <li>Åpningstider: søndag til torsdag 07:00-21:00, fredager 07:00-15:00 (også i ferier).</li>
      <li>Betaling skjer etter timen med bankkort eller Vipps, direkte gjennom SMS på telefonen.</li>
      <li>Avbestilling eller timeendringer må gjøres senest 24 timer før timen, ellers belastes timen i sin helhet.</li>
      <li>Journalføring og betaling skjer trygt via Konfidens.no (et kryptert og godkjent system).</li>
      <li>Vi har taushetsplikt og følger GDPR, helsepersonelloven og pasient- og brukerrettighetsloven.</li>
      <li>Siden Øystein er sertifisert psykoterapeut, og ikke psykolog, regnes terapien hans ikke som helsebehandling i Norge, juridisk sett.</li>
      <li>Mange forsikringsselskaper og bedriftshelsetjenester dekker utgifter til 
        behandling hos psykolog inntil 10 timer. 
        Undersøk med ditt forsikringsselskap eller arbeidsgiver om det gjelder deg.</li>
      <li>Følg oss for oppdateringer, arrangementer og helsesamlinger på sosiale medier (se nedenfor).</li>
    </ul>
    <p>
      📖 Les mer i våre dokumenter: 
      <a href="/Informasjonsskriv Elumo Terapeutiske Tjenester.pdf" 
      target="_blank" rel="noopener noreferrer"> Informasjonsskriv</a> og 
      <a href="/Personvernerklæring Elumo Terapeutiske Tjenester.pdf" 
      target="_blank" rel="noopener noreferrer"> Personvernerklæring</a>
    </p>
  </div>
</div>
{/* Kontakt */}
<section id="contact" className="section contact">
  <h3>Kontakt oss</h3>

  {/* Flex-container for tekst + bilde */}
  <div className="contact-container">
    {/* Info-boks */}
    <div className="contact-info-box">
      <p><strong>Telefon</strong></p>
      <p>Øystein: <a className="phone-link" href="tel:+4748178629">+47 481 78 629</a></p>
      <p>Natalia: <a className="phone-link" href="tel:+47498663488">+47 986 63 488</a></p>

      <p><strong>E-post</strong></p>
      <p><a className="email-link" href="mailto:elumoterapeutisketjenester@gmail.com">elumoterapeutisketjenester@gmail.com</a></p>

      <div className="follow-us">
        <p><strong>Følg oss</strong></p>
        <div className="social-links">
          <a href="https://www.instagram.com/elumoterapeutisketjenester/?hl=no" target="_blank" rel="noopener noreferrer" className="social-link">
            <img src={instagramIcon} alt="Instagram" />
            <span>Instagram</span>
          </a>
          <a href="https://www.facebook.com/people/Elumo-Terapeutiske-Tjenester/61577333022163/" target="_blank" rel="noopener noreferrer" className="social-link facebook">
            <img src={facebookIcon} alt="Facebook" />
            <span>Facebook</span>
          </a>
        </div>
      </div>
    </div>

    {/* Bilde plassert som søsken til info-boksen */}
    <img src={kontaktoss} alt="Om oss" className="om-oss-bilde" />
  </div>

  <p className="safety-warning">
    &#128680; Ved akutt behov for hjelp, kontakt legevakten 116 117 eller 113 for livstruende situasjoner. <br/> 
    ⚠️ Ikke del sensitive personopplysninger om deg selv eller andre via SMS eller e-post.
  </p>
</section>


{/* Avslutningsboks */}
<div className="om-oss-container avslutningsboks">
  <div className="om-oss-tekst avslutnings-tekst">
    <h2>Vi håper å høre fra deg!</h2>
  </div>
  <img
    src={håp}
    alt="Vi håper å høre fra deg"
    className="om-oss-bilde avslutnings-bilde"
  />
</div>

        </main>
        <footer className="App-footer">
          <div className="footer-content">
            <p>© {new Date().getFullYear()} Elumo Terapeutiske Tjenester</p>
            <p>Helsefremmende, helbredende og helhetlig.</p>
          </div>
        </footer>
      </div>
    </>
  );
}
